import React, { useEffect } from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { useDispatch } from 'react-redux';
import ContainerRowSelection from '../Components/ContainerRowSelection';
import ContainerFloorSelection from '../Components/ContainerFloorSelection';
import ScreenLayout from '../Components/ScreenLayout';
import ActionButton from '../Components/ActionButton';
import { Footer } from '../Components/Footer';
import Divider from '@material-ui/core/Divider';
import { useHistory } from 'react-router-dom';
import ThemeProvider from './ThemeProvider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      padding: theme.spacing(4),
      width: '100%',
      marginTop: 'auto',
    },
    btnNext: {
      float: 'right',
    },
  }),
  { name: 'ContainerSetup' }
);
export const ContainerSetup = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(withGlobalLoader(configuratorActions.fetchInitialConfiguration()));
  }, [dispatch]);

  const history = useHistory();

  const handleClick = async (link) => {
    try {
      history.push(link);
    } catch (e) {
      alert(`could not load configuration: ${link}`);
    }
  };

  return (
    <ThemeProvider>
      <ScreenLayout title={t('containerRowFloorSelection.title')}>
        <Divider />
        <div className={classes.container}>
          <ContainerRowSelection />
          <ContainerFloorSelection />
        </div>
        <Divider />
        <div className={classes.container}>
          <ActionButton
            className={classes.btnNext}
            label={t('next')}
            onClick={() => handleClick(`/identifier:containeranlage`)}
          />
        </div>
        <Footer />
      </ScreenLayout>
    </ThemeProvider>
  );
};

ContainerSetup.propTypes = {};

ContainerSetup.defaultProps = {};

export default ContainerSetup;
